<template>
  <app-tooltip
    v-if="tooltipText"
    :text="tooltipText"
    :max-width="tooltipWidth"
  >
    <template #activator>
      <button
        class="button-link"
        :class="{ 'with-icon': hasIcon }"
        @click="handleClick"
      >
        <AppIcon
          v-if="iconName"
          :name="iconName"
          width="18px"
          class="button-link-icon"
        />
        <span class="button-link-text">
          {{ label }}
        </span>
      </button>
    </template>
  </app-tooltip>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

export default defineComponent({
  name: "LoginButtonLink",
  components: {
    AppTooltip,
    AppIcon,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    iconName: {
      type: String,
      default: "",
    },
    tooltipText: {
      type: String,
      default: "",
    },
    tooltipWidth: {
      type: String,
      default: "186px",
    },
    showTooltipOnHover: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["click"],
  setup(props, { emit }) {

    const hasIcon = computed(() => !!props.iconName);

    const handleClick = () => {
      emit("click");
    };

    return {
      hasIcon,
      handleClick,
    };
  },
});
</script>

<style scoped>
.button-link {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 18px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #979797 !important;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
}

.button-link:hover {
  cursor: pointer;
  /* text-decoration: underline; */
}

.button-link.with-icon {
  gap: 4px;
}

.button-link-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.button-link-text {
  display: inline-block;
  color: #979797 !important;
}
</style>
